module.exports = __webpack_public_path__ + "images/exterior-3d-5ea80b3e524ae42fc9296ec6454b9f85.svg";